import { Tab } from '@headlessui/react';
import PropTypes from 'prop-types';

function RcTab(props) {
  const { name } = props;

  return (
    <Tab
      className={({ selected }) =>
        `${selected && 'bg-white font-bold text-rcprimary-400'} ${
          !selected &&
          'border-transparent bg-white/60 font-medium text-black hover:border-rcprimary-400 hover:bg-white hover:text-rcprimary-400'
        } whitespace-nowrap rounded-t-lg px-6 py-3 text-sm focus:outline-hidden`
      }
    >
      {name}
    </Tab>
  );
}

RcTab.propTypes = {
  name: PropTypes.string.isRequired,
};

export default RcTab;
